export default __webpack_public_path__ + "64f8970ce4edecdf1f01e11f3d7fe76a.png";